import { Control, Controller, FieldErrors, UseFormClearErrors, UseFormSetValue } from "react-hook-form";
import React, { useContext, useState, useEffect } from "react";

import { IFieldProperties } from "../InputFields.types";
import block from 'bem-css-modules';
import { sanitizeContent as s } from "../../../../util/functions";
import { AppContext } from "../../../../util/context";
import styles from "./DatePickerInput.module.scss";
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { de } from 'date-fns/locale/de'; 
import { fr } from 'date-fns/locale/fr'; 
import { enGB } from 'date-fns/locale/en-GB'; 
import { format, Locale } from 'date-fns';

const DatePickerInput = (props: { fieldData: IFieldProperties, setValue: UseFormSetValue<any>, clearErrors: UseFormClearErrors<any>, errors: FieldErrors, control: Control }) => {
  const { 
    fieldData: { 
      label,
      title,
      placeholder,
      validationText,
      disableFuture,
      disablePast,
      settings: [{
        crmProperty,
        required
      }]
    },
    setValue,
    clearErrors,
    errors,
    control
  } = props

  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);
  const context = useContext(AppContext);
  const { settings: { locale } } = context;

  useEffect(()=>{
    registerLocale('de', de as unknown as Locale); 
    registerLocale('fr', fr as unknown as Locale); 
    registerLocale('en', enGB as unknown as Locale); 
    setDefaultLocale(locale.substring(0,2));
  },[locale])
  
  const handleDateChange = (newDate: Date | null) => {
    clearErrors(label);
    if (newDate) {
      const formattedDate = format(newDate, 'yyyy-MM-dd');
      setSelectedDate(new Date(formattedDate));
      setValue(crmProperty, formattedDate);
    } else {
      setSelectedDate(undefined);
      setValue(crmProperty, null);
    }
  };
  
  const b = block(styles);

  return (
    <div className={`${b()}`}>
      {title && (
        <h3 className={b("title")} dangerouslySetInnerHTML={{ __html: s(title) }}/>
      )}
      <Controller
        name={crmProperty}
        control={control}
        rules={{ required: required }}
        render={() => (
          <DatePicker 
            className={b("date-picker")}
            dateFormat="dd/MM/yyyy"
            selected={selectedDate}
            placeholderText={placeholder}
            maxDate={disableFuture ? new Date() : undefined}
            minDate={disablePast ? new Date() : undefined}
            onChange={(date) => handleDateChange(date)} 
            withPortal
          />
        )}
      />

      {/* required check & file (type + size) check */}
      {errors[crmProperty] &&  (
        <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
      )}
    </div>
  )
}

export default DatePickerInput;